import { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { SummaryCardSkeleton } from "../../../Components/Molecules/DashboardSkeleton";
import { useContaInternacionalBalances } from "../../../Hooks/useContaInternacionalBalances";
import { ContaInternacionalDepositarModal } from "./components/ContaInternacionalDepositarModal";
import { ContaInternacionalMovimentarModal } from "./components/ContaInternacionalMovimentarModal";
import { ContaInternacionalTransferirModal } from "./components/ContaInternacionalTransferirModal";
import { ContaInternacionalDadosModal } from "./components/ContaInternacionalDadosModal";
import { ContaInternacionalShortcutMenu } from "./components/ContaInternacionalShortcutMenu";
import { CurrencyBalanceCard } from "./components/CurrencyBalanceCard";
import { MovementsList } from "./components/MovementsList";
import { CONTA_INTERNACIONAL_HOME_PATH } from "./constants";

export const ContaInternacionalDetalhe = () => {
  const { hasPermission } = useAuth();
  const canTransfer = hasPermission("internationaltransfer");
  const { currencyId } = useParams();
  const { getCurrencyById, balancesLoading } = useContaInternacionalBalances();
  const currency = getCurrencyById(currencyId);
  const [dadosModalOpen, setDadosModalOpen] = useState(false);
  const [depositarModalOpen, setDepositarModalOpen] = useState(false);
  const [movimentarModalOpen, setMovimentarModalOpen] = useState(false);
  const [transferirModalOpen, setTransferirModalOpen] = useState(false);

  if (balancesLoading && !currency) {
    return (
      <div className="w-full">
        <PageHeaderWithBack title="…" backTo={CONTA_INTERNACIONAL_HOME_PATH} />
        <SummaryCardSkeleton />
      </div>
    );
  }

  if (!currency) {
    return <Redirect to={CONTA_INTERNACIONAL_HOME_PATH} />;
  }

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title={currency.label}
        backTo={CONTA_INTERNACIONAL_HOME_PATH}
      />

      <CurrencyBalanceCard
        currency={currency}
        variant="detail"
        loadingRates={balancesLoading}
      />

      <ContaInternacionalShortcutMenu
        onOpenDados={() => setDadosModalOpen(true)}
        onOpenDepositar={() => setDepositarModalOpen(true)}
        onOpenMovimentar={canTransfer ? () => setMovimentarModalOpen(true) : undefined}
        onOpenTransferir={canTransfer ? () => setTransferirModalOpen(true) : undefined}
      />

      <MovementsList currencyId={currency.id} />

      <ContaInternacionalDadosModal
        open={dadosModalOpen}
        onClose={() => setDadosModalOpen(false)}
        currencyId={currency.id}
      />

      <ContaInternacionalDepositarModal
        open={depositarModalOpen}
        onClose={() => setDepositarModalOpen(false)}
        currencyId={currency.id}
      />

      {canTransfer ? (
        <ContaInternacionalMovimentarModal
          open={movimentarModalOpen}
          onClose={() => setMovimentarModalOpen(false)}
          currencyId={currency.id}
        />
      ) : null}

      {canTransfer ? (
        <ContaInternacionalTransferirModal
          open={transferirModalOpen}
          onClose={() => setTransferirModalOpen(false)}
          currencyId={currency.id}
        />
      ) : null}
    </div>
  );
};
